import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import { deleteItem, saveItem, updateFolder } from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import { stringIsEmpty } from 'utils/utils'

import FolderSelector from '../modal-components/folder-selector'

import InputStandard from 'components/input/standard'

class ModalFolder extends Component {
	state = {
		id: '',
		name: '',
		account_id: '',
		project_id: '',
		folder: {},
		folder_id: null,
		file_folder_id: null,
		isParentSelectorOpen: false
	}

	handleChange = e => {
		this.setState({
			name: e.target.value
		})
	}

	componentDidMount(){
		const {
			data,
			allFolders,
			allFileFilders,
			folderChain,
			operation,
			currentAccount
		} = this.props

		const {
			isFileFolder,
			currentProject
		} = data

		const editedObject = data.folder ? data.folder : null

		const tempState = {
			...data,
			account_id: currentAccount.id,
		}

		if(currentProject){
			tempState.project_id = currentProject.id
		}

		if(!editedObject){
			let normalisedFolderChain = []
			let normalisedFolders = {}

			if(isFileFolder){
				if(allFileFilders){
					normalisedFolders = allFileFilders
				}

				if(data.folderChain){
					normalisedFolderChain = data.folderChain
				}
			}else{
				if(allFolders){
					normalisedFolders = allFolders
				}

				if(folderChain){
					normalisedFolderChain = folderChain
				}
			}

			const firstFolder = normalisedFolders[normalisedFolderChain[(normalisedFolderChain.length - 1)]]

			const folderId = firstFolder ? firstFolder.id : null

			tempState.folder_id = folderId
			tempState.file_folder_id = folderId
		}else{
			if(isFileFolder){
				tempState.file_folder_id = editedObject.file_folder_id
			}else{
				tempState.folder_id = editedObject.folder_id
			}
		}

		// Can be cleaned, maybe use state rather than refs when getting / setting input value.
		if(operation === 'edit') {
			tempState.name = editedObject.name
			tempState.id = editedObject.id
		}

		this.setState(tempState)
		
    	setTimeout(_ => {
    		this.refs.folderName.inputRef.focus()
    	}, 1);
	}

	toggleMenu = _ => {
		this.setState({
			isParentSelectorOpen: !this.state.isParentSelectorOpen
		})
	}

	forceCloseMenu = _ => {
		this.setState({
			isParentSelectorOpen: false
		})
	}

	saveFolder = _ => {
		const {
			isLoading,
			operation,
			deleteItem,
			updateFolder,
			closeCallback,
			saveItem,
			setLoading,
			handleError
		} = this.props

		const {
			isFileFolder
		} = this.props.data

		const {
			id,
			name,
			folder_id,
			file_folder_id
		} = this.state

		if(isLoading){
			return 
		}

		if(stringIsEmpty(name)) {
			handleError('Folder name can not be empty')
			return
		}

		if (operation === 'edit') {
			const data = {
				id,
				name,
				folder_id,
				file_folder_id
			}

			// just removed from state, so it detaches from its parent
			deleteItem('folder', this.props.data.folder, null, null, true)

			updateFolder(data, isFileFolder ? 'file_folder' : 'folder', _ => {
				closeCallback()
			})
		} else {
			saveItem(this.state, isFileFolder ? 'file_folder' : 'folder', _ => {
				setLoading(false)
				closeCallback()
			})
		}

	}

	handleChange = e => {
		this.setState({
			name: e.target.value
		})
	}

	changeParent = folderId => {
		this.setState({
			folder_id: folderId,
			file_folder_id: folderId,
			isParentSelectorOpen: false
		})
	}

	render() {
		const {
			handleDismiss,
			validateResponse,
			closeCallback,
			data
		} = this.props
		
		const {
			isFileFolder,
			folder,
			currentProject
		} = data

		const {
			name,
			isParentSelectorOpen,
			folder_id,
			file_folder_id
		} = this.state

		let stateFolderId = null

		if(isFileFolder && file_folder_id){
			stateFolderId = file_folder_id
		}else if(folder_id){
			stateFolderId = folder_id
		}

		const initialFolderId = folder ? folder.id : null

		return(
			<div>
				<div className={'borders input-wrap'}>
					<InputStandard 
						outlineOnFocus={true} 
						ref="folderName" 
						callback={this.saveFolder} 
						value={name} 
						onChange={this.handleChange} 
						placeholder={isFileFolder ? 'File folder name' : 'Folder name'}
					/>
					<FolderSelector 
						isFolder={true} 
						folderId={initialFolderId} 
						isOpened={isParentSelectorOpen} 
						forceCloseMenu={_ => {this.forceCloseMenu()}} 
						toggleMenu={_ => {this.toggleMenu()}} 
						parentFolderChange={this.changeParent} 
						currentParentId={stateFolderId} 
						isFileFolder={isFileFolder}
						currentProject={currentProject}
					/>
				</div>
				<ValidateResponse 
					dismissCallback={handleDismiss} 
					response={validateResponse} 
				/>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={_ => {this.saveFolder()}} 
					label={'Yep'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
  return {
	currentAccount: state.account.currentAccount,
	operation: state.modal.operation,
	allFolders: state.account.entities.folders,
	allFileFilders: state.account.entities.file_folders,
	folderChain: state.account.folderChain,
  }
}

const ModalFolderWithValidateResponse = withValidateResponse(ModalFolder)

export default connect(mapStateToProps, { saveItem, deleteItem, updateFolder })(ModalFolderWithValidateResponse)



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-folder.jsx